// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2k95D","left":"StickyBox_left__3BaBq","right":"StickyBox_right__2eb3c"};